var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeRetos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.885,
    height: 32,
    viewBox: "0 0 34.885 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "home-default",
    d: "M38.225,14.6,22.231,4.427a1.436,1.436,0,0,0-1.556,0L4.681,14.6a1.454,1.454,0,0,0,1.556,2.457l.669-.422V36.2H30.17a5.815,5.815,0,0,0,5.816-5.816V16.641l.669.422a1.413,1.413,0,0,0,.785.233,1.449,1.449,0,0,0,.771-2.675ZM24.354,33.275H18.538V21.643h5.816Zm8.724-2.908a2.917,2.917,0,0,1-2.908,2.908H27.262V21.643a2.917,2.917,0,0,0-2.908-2.908H18.538a2.917,2.917,0,0,0-2.908,2.908V33.275H9.813v-18.5l11.632-7.4,11.632,7.4Z",
    transform: "translate(-4.006 -4.197)",
    fill: "#003865"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeRetos);
export default __webpack_public_path__ + "static/media/home-retos.5f51f00e4aab010f92648369eb88f623.svg";
export { ForwardRef as ReactComponent };